(() => {
  if (window.cwsFloatingControls) return;
  window.cwsFloatingControls = true;

  // KK-1910: the product page's sticky add to cart bar is fixed to the bottom of the screen and its
  // height depends on the product (variant pickers add a row). While it shows, the back to top arrow
  // and the chat button move up by --cws-float-lift, set here from the measured bar, so they sit
  // above it with the same 12px gap as between the two controls. The styles live in
  // sections/cws-runtime-guards.liquid.
  const gap = 12;
  const root = document.documentElement;
  let frame = 0;

  const update = () => {
    frame = 0;
    const arrow = document.querySelector('.scroll_top');
    const arrowBottom = arrow ? Number.parseFloat(window.getComputedStyle(arrow).bottom) || 40 : 40;
    let lift = 0;

    document.querySelectorAll('.sticky_add_to_cart').forEach((bar) => {
      if (window.getComputedStyle(bar).display === 'none') return;
      const rect = bar.getBoundingClientRect();
      if (!rect.height || rect.top >= window.innerHeight) return;
      // The floating bar variant is centred on desktop and may not reach the controls' column.
      if (rect.right < window.innerWidth - 140) return;
      lift = Math.max(lift, window.innerHeight - rect.top + gap - arrowBottom);
    });

    root.style.setProperty('--cws-float-lift', `${Math.max(0, Math.round(lift))}px`);
  };

  const schedule = () => {
    if (!frame) frame = window.requestAnimationFrame(update);
  };

  const init = () => {
    const bars = document.querySelectorAll('.sticky_add_to_cart');
    if (!bars.length) return;

    // Alpine shows and hides the bar through its style and transition classes, without a scroll event.
    const observer = new MutationObserver(schedule);
    bars.forEach((bar) => {
      observer.observe(bar, { attributes: true, attributeFilter: ['style', 'class'] });
      bar.addEventListener('transitionend', schedule);
    });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    schedule();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
